import { render, staticRenderFns } from "./suppliersView.vue?vue&type=template&id=1cf256a6&scoped=true"
import script from "./suppliersView.vue?vue&type=script&lang=js"
export * from "./suppliersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf256a6",
  null
  
)

export default component.exports